import { shallowEqual } from 'react-redux';

import { AppState, useAppSelector } from '@redux/store';

export const useAuthUser = () =>
  useAppSelector(
    ({ auth }: AppState) => ({
      user: auth.user,
      isAnonymous: auth.isAnonymous,
    }),
    shallowEqual,
  );

export const useForgotPasswordEmail = () =>
  useAppSelector(({ auth }: AppState) => auth.forgotPassword.email);
